<header>
    <mat-toolbar style="background-color: #000832;color:#ffffff">
        <button *ngIf="isMobile" mat-icon-button (click)="drawer.toggle()">
            <mat-icon>menu</mat-icon>
        </button>
        <!-- <span>My App</span> -->
        <div *ngIf="isMobile" class="mobile-logo-img-div">
            <img [src]="appIconPaths.PARAMOUNT_CP_CENTRAL_LOGO" class="mobile-logo-img" alt="Logo" />
        </div>
        <div *ngIf="!isMobile" style="width:100%;justify-content: center;display: flex;">
            <img [src]="appIconPaths.PARAMOUNT_CP_CENTRAL_LOGO" alt="Logo" class="logo-img" />
        </div>
        <div *ngIf="!isMobile" class="align-item-center" style="width:100%">
            <span class=" btn cursor-pointer" style="text-underline-position: below;" (click)="clickExtRegistration(userType)"
                matFab extended>
                Request New User</span><span class="btn-gap">/</span><span class="cursor-pointer"
                (click)="onLogout()">Log Off
            </span>
            <img [src]="appIconPaths.USER_ICON" alt="Logo" style="width: 28px; margin-left: 10px;" />
        </div>
    </mat-toolbar>
</header>